export default class SlidingVisibleElement{
    static #isScrolling = false
    static #listElements = []
    static #groupedElements = new Map();
   

    #elem = null
    #baseDelay = 50

    get elem(){
        return this.#elem
    }

    static init(){
        this.#listElements=[];
        this.#groupedElements.clear();
        let elems = document.getElementsByClassName('sliding-elem')
        for(let el of elems){
            let slidingElem = new SlidingVisibleElement(el)
            this.#listElements.push(slidingElem)
            const parent = el.parentElement;
            if (!this.#groupedElements.has(parent)) {
                this.#groupedElements.set(parent, []);
            }
            this.#groupedElements.get(parent).push(slidingElem);
        }

        for (let [parent, group] of this.#groupedElements) {
            group.sort((a, b) => a.elem.offsetTop - b.elem.offsetTop);
        }

        for(let el of this.#listElements){
            if(el.isPartiallyVisible())
                el.active()
        }

        window.addEventListener("scroll", this.#throttleScroll.bind(this), false);
        document.addEventListener("DOMContentLoaded", this.#scrolling.bind(this), false);
    }

    static #throttleScroll() {
        if (!this.#isScrolling) {
            requestAnimationFrame(()=>{
                this.#scrolling();
                this.#isScrolling = false;
            });
        }
        this.#isScrolling = true;
    }

    static #scrolling(){
        for (const item of this.#listElements) {
            if (item.isPartiallyVisible() && !item.elem.classList.contains('sliding-active')) {
                item.active();
            } /*else { 
                item.disactive();
            }*/
        }
    }

    constructor(el){
        this.#elem = el
    }

    isPartiallyVisible() {
        let rect = this.#elem.getBoundingClientRect();
        let top = rect.top;
        let bottom = rect.bottom;
        let height = rect.height;
        return ((top + height >= 0) && (height + window.innerHeight >= bottom));
    }

    active(){
        const parent = this.#elem.parentElement;
        const group = SlidingVisibleElement.#groupedElements.get(parent);
        if (!group) return;
        const index = group.indexOf(this);
        if (this.#elem.classList.contains('sliding-active')) return;
        const delay = index * this.#baseDelay; 
        setTimeout(() => {
            this.#elem.classList.add("sliding-active");
        }, delay);
    }
    disactive(){
        this.#elem.classList.remove("sliding-active")
    }
 
    isFullyVisible() {
        let rect = this.#elem.getBoundingClientRect();
        let top = rect.top;
        let bottom = rect.bottom;
        return ((top >= 0) && (bottom <= window.innerHeight));
    }
}